function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M53.8389 32.9385V15.3959H50.8662V14.6619H61.289C62.6469 14.6619 63.7479 14.772 64.6287 15.0289C65.5095 15.2491 66.2435 15.7629 66.9041 16.4969C67.528 17.2309 67.8583 18.075 67.8583 19.0659C67.8583 20.277 67.3812 21.2312 66.4637 21.9652C65.5462 22.6992 63.9681 23.2864 61.7661 23.6534V23.7268C63.3442 24.0204 64.6654 24.6443 65.6563 25.5251C66.6839 26.4059 67.161 27.9473 67.161 30.0759C67.161 31.287 67.3078 32.0944 67.6014 32.4247C67.895 32.755 68.2987 32.9385 68.8125 32.9385C69.1428 32.9385 69.5465 32.8651 69.9869 32.755V33.4523C69.1795 33.7459 68.3721 33.8927 67.6014 33.8927C66.06 33.8927 64.959 33.4523 64.2984 32.6082C63.6745 31.7274 63.3442 30.8833 63.3809 30.0759L63.4543 27.6537C63.4543 26.8096 63.1974 26.0022 62.6469 25.1581C62.0964 24.3507 60.8853 23.947 59.0136 23.947H57.252V32.9752H60.2247V33.7092H50.8662V32.9752H53.8389V32.9385ZM57.1786 15.3959V23.2497H59.7109C60.8119 23.2497 61.656 23.1763 62.2065 23.0295C62.7937 22.8827 63.2341 22.5157 63.6011 21.8918C63.9314 21.2679 64.1149 20.277 64.1149 18.9558C64.1149 17.8548 63.9314 17.0474 63.6011 16.5336C63.2341 16.0198 62.8304 15.7262 62.3166 15.5794C61.8028 15.4693 61.1789 15.3959 60.3715 15.3959H57.1786Z",
  fill: "url(#paint0_linear)"
}), React.createElement("path", {
  d: "M0 43.8018C4.8077 43.7284 9.61541 43.6917 14.4598 43.6183L28.9196 43.5082C38.535 43.4348 48.1871 43.4715 57.8025 43.4348C67.418 43.4715 77.0701 43.4715 86.6855 43.5082L101.145 43.6183C105.953 43.6917 116.009 43.7284 120.853 43.8018C116.045 43.8752 105.99 43.9119 101.145 43.9853L86.6855 44.0954C77.0701 44.1688 67.418 44.1321 57.8025 44.1688C48.1871 44.1321 38.535 44.1321 28.9196 44.0954L14.4598 43.9853C9.61541 43.9119 4.8077 43.9119 0 43.8018Z",
  fill: "url(#paint1_linear)"
}), React.createElement("path", {
  d: "M0 61.0875C4.8077 61.0141 9.61541 60.9774 14.4598 60.904L28.9196 60.7939C38.535 60.7205 48.1871 60.7572 57.8025 60.7205C67.418 60.7572 77.0701 60.7572 86.6855 60.7939L101.145 60.904C105.953 60.9774 116.009 61.0141 120.853 61.0875C116.045 61.1609 105.99 61.1976 101.145 61.271L86.6855 61.3811C77.0701 61.4545 67.418 61.4178 57.8025 61.4545C48.1871 61.4178 38.535 61.4178 28.9196 61.3811L14.4598 61.271C9.61541 61.1976 4.8077 61.1976 0 61.0875Z",
  fill: "url(#paint2_linear)"
}), React.createElement("path", {
  d: "M8.80775 57.1606V47.5819H7.15625V47.1782H12.8448C13.5788 47.1782 14.2027 47.2516 14.6798 47.3617C15.1569 47.5085 15.5606 47.7654 15.9276 48.1691C16.2579 48.5728 16.4414 49.0499 16.4414 49.5637C16.4414 50.2243 16.1845 50.7381 15.6707 51.1418C15.1569 51.5455 14.3128 51.8391 13.1017 52.0593V52.096C13.9825 52.2795 14.6798 52.6098 15.2303 53.0869C15.7808 53.564 16.0744 54.4081 16.0744 55.5825C16.0744 56.2431 16.1478 56.6835 16.2946 56.867C16.4414 57.0505 16.6616 57.1606 16.9552 57.1606C17.1387 57.1606 17.3589 57.1239 17.6158 57.0505V57.4175C17.1754 57.5643 16.735 57.6377 16.3313 57.6377C15.4872 57.6377 14.8633 57.4175 14.533 56.9404C14.166 56.4633 14.0192 55.9862 14.0192 55.5458L14.0559 54.2246C14.0559 53.7475 13.9091 53.3071 13.6155 52.8667C13.3219 52.4263 12.6613 52.2061 11.6337 52.2061H10.6795V57.1239H12.331V57.5276H7.19295V57.1239H8.80775V57.1606ZM10.6795 47.5819V51.8758H12.0741C12.6613 51.8758 13.1384 51.8391 13.432 51.7657C13.7623 51.6923 13.9825 51.4721 14.2027 51.1418C14.4229 50.8115 14.4963 50.261 14.4963 49.527C14.4963 48.9398 14.3862 48.4994 14.2027 48.2058C14.0192 47.9122 13.799 47.7654 13.5054 47.692C13.2485 47.6186 12.8815 47.5819 12.4411 47.5819H10.6795Z",
  fill: "url(#paint3_linear)"
}), React.createElement("path", {
  d: "M23.0842 57.8213C21.7263 57.8213 20.5886 57.2708 19.6711 56.1331C18.7169 54.9954 18.2765 53.821 18.2765 52.5365C18.2765 50.9951 18.7536 49.6739 19.7445 48.6096C20.7354 47.5086 21.8731 46.9948 23.1576 46.9948C24.3687 46.9948 25.4697 47.5453 26.4606 48.6463C27.4148 49.7473 27.9286 50.9951 27.9286 52.4264C27.9286 53.8577 27.4515 55.1422 26.4606 56.2432C25.4697 57.2708 24.3687 57.8213 23.0842 57.8213ZM23.1209 47.3618C22.5704 47.3618 22.0566 47.5086 21.5795 47.7655C21.1391 48.0224 20.8088 48.4628 20.662 49.1234C20.5152 49.784 20.4051 50.885 20.4051 52.4998C20.4051 53.6008 20.4418 54.4816 20.5519 55.1422C20.662 55.8028 20.8822 56.3533 21.2492 56.7937C21.6162 57.2341 22.2401 57.4543 23.0475 57.4543C23.5246 57.4543 24.0384 57.3075 24.5522 57.0506C25.066 56.7937 25.3596 56.2799 25.5431 55.5092C25.6899 54.7385 25.7633 53.5641 25.7633 51.9493C25.7633 50.4813 25.6532 49.4904 25.4697 48.9399C25.2862 48.3894 24.9926 47.9857 24.5522 47.7288C24.1485 47.4719 23.6714 47.3618 23.1209 47.3618Z",
  fill: "url(#paint4_linear)"
}), React.createElement("path", {
  d: "M33.9109 57.8213C32.553 57.8213 31.4152 57.2708 30.4977 56.1331C29.5435 54.9954 29.1031 53.821 29.1031 52.5365C29.1031 50.9951 29.5802 49.6739 30.5712 48.6096C31.5621 47.5086 32.6998 46.9948 33.9843 46.9948C35.1954 46.9948 36.2964 47.5453 37.2873 48.6463C38.2415 49.7473 38.7553 50.9951 38.7553 52.4264C38.7553 53.8577 38.2782 55.1422 37.2873 56.2432C36.2964 57.2708 35.1954 57.8213 33.9109 57.8213ZM33.9476 47.3618C33.3971 47.3618 32.8833 47.5086 32.4062 47.7655C31.9658 48.0224 31.6355 48.4628 31.4887 49.1234C31.3419 49.784 31.2317 50.885 31.2317 52.4998C31.2317 53.6008 31.2685 54.4816 31.3786 55.1422C31.4887 55.8028 31.7089 56.3533 32.0759 56.7937C32.4429 57.2341 33.0668 57.4543 33.8742 57.4543C34.388 57.4543 34.8651 57.3075 35.3789 57.0506C35.8927 56.7937 36.1863 56.2799 36.3698 55.5092C36.5166 54.7385 36.59 53.5641 36.59 51.9493C36.59 50.4813 36.4799 49.4904 36.2964 48.9399C36.1129 48.3894 35.8193 47.9857 35.3789 47.7288C34.9752 47.4719 34.4981 47.3618 33.9476 47.3618Z",
  fill: "url(#paint5_linear)"
}), React.createElement("path", {
  d: "M39.8196 47.1782H43.5263L45.765 54.5182H45.8017L48.0404 47.1782H51.6737V47.5819H50.1323V57.1606H51.6737V57.5643H46.7926V57.1606H48.3707V47.3984H48.334L45.2512 57.5643H44.8842L41.8014 47.3984H41.7647V57.1606H43.3428V57.5643H39.8196V57.1606H41.361V47.5819H39.8196V47.1782Z",
  fill: "url(#paint6_linear)"
}), React.createElement("path", {
  d: "M59.8577 52.83V57.1973H61.5459V57.601H56.3712V57.1973H58.0227V47.6186H56.3712V47.2149H61.7294C62.9405 47.2149 63.858 47.4718 64.4452 48.0223C65.0691 48.5728 65.3627 49.2334 65.3627 50.0041C65.3627 50.8115 65.0691 51.4721 64.4452 52.0226C63.8213 52.5731 62.7937 52.83 61.3624 52.83H59.8577ZM59.8577 47.5819V52.4263H60.8486C61.3624 52.4263 61.8028 52.3896 62.1331 52.2795C62.4634 52.2061 62.7937 51.9492 63.0139 51.5822C63.2708 51.2152 63.3809 50.628 63.3809 49.8206C63.3809 49.1233 63.2708 48.6095 63.0506 48.2792C62.8304 47.9489 62.5735 47.7654 62.2799 47.692C61.9863 47.6186 61.6193 47.5819 61.1789 47.5819H59.8577Z",
  fill: "url(#paint7_linear)"
}), React.createElement("path", {
  d: "M70.1705 54.3347H66.8675L65.8032 57.1606H67.7116V57.5643H63.9315V57.1606H65.3628L69.1429 46.9213H69.3998L73.0331 57.1606H74.4277V57.5643H69.4732V57.1606H71.1614L70.1705 54.3347ZM67.051 53.931H70.0604L68.5924 49.7839H68.5557L67.051 53.931Z",
  fill: "url(#paint8_linear)"
}), React.createElement("path", {
  d: "M78.6114 47.5819V57.1606H80.9235C81.3639 57.1606 81.7309 57.1239 81.9878 57.0505C82.2447 56.9771 82.5016 56.8303 82.7585 56.5734C83.0154 56.3165 83.1989 56.0229 83.3457 55.6559C83.4925 55.2889 83.6393 54.8118 83.7861 54.1879H84.1531L83.8595 57.5643H75.1249V57.1606H76.7764V47.5819H75.1249V47.1782H80.3363V47.5819H78.6114Z",
  fill: "url(#paint9_linear)"
}), React.createElement("path", {
  d: "M90.8693 54.3347H87.5663L86.5019 57.1606H88.4103V57.5643H84.6302V57.1606H86.0615L89.8417 46.9213H90.0986L93.7319 57.1606H95.1265V57.5643H90.172V57.1606H91.8602L90.8693 54.3347ZM87.713 53.931H90.7225L89.2544 49.7839H89.2178L87.713 53.931Z",
  fill: "url(#paint10_linear)"
}), React.createElement("path", {
  d: "M103.127 47.0681V50.1509H102.797C102.43 48.2792 101.512 47.325 100.008 47.325C99.2001 47.325 98.6129 47.6553 98.2459 48.2792C97.8789 48.9031 97.6954 50.261 97.6954 52.2795C97.6954 53.9677 97.7688 55.1054 97.9523 55.6926C98.0991 56.2798 98.3927 56.7202 98.7964 56.9771C99.2001 57.234 99.6405 57.3808 100.118 57.3808C100.742 57.3808 101.329 57.1606 101.879 56.6835C102.43 56.2064 102.833 55.4724 103.127 54.4448H103.494L103.384 57.601H103.054C102.944 57.2707 102.76 56.9771 102.503 56.7569C101.696 57.4175 100.852 57.7845 99.9708 57.7845C98.8698 57.7845 97.8789 57.2707 96.9614 56.2431C96.0439 55.2155 95.6035 53.931 95.6035 52.4263C95.6035 50.8849 96.0439 49.6004 96.9247 48.5361C97.8055 47.4718 98.8331 46.9213 100.008 46.9213C100.888 46.9213 101.696 47.2516 102.393 47.8755C102.577 47.5452 102.76 47.2883 102.833 47.0314H103.127V47.0681Z",
  fill: "url(#paint11_linear)"
}), React.createElement("path", {
  d: "M108.118 47.5819V52.0226H109.072C109.403 52.0226 109.696 51.9859 109.917 51.9125C110.137 51.8391 110.357 51.6556 110.54 51.3987C110.724 51.1051 110.834 50.6647 110.871 50.0775H111.274V54.4815H110.834C110.797 53.6374 110.614 53.0869 110.357 52.83C110.063 52.5731 109.66 52.4263 109.072 52.4263H108.118V57.1606H110.247C111.458 57.1606 112.265 56.9037 112.742 56.3899C113.22 55.8761 113.476 55.1054 113.55 54.0778H113.954L113.843 57.5643H104.632V57.1606H106.283V47.5819H104.632V47.1782H113.44L113.623 49.9674H113.22C113.073 49.1233 112.816 48.5361 112.375 48.1324C111.972 47.7654 111.274 47.5819 110.284 47.5819H108.118Z",
  fill: "url(#paint12_linear)"
}), React.createElement("path", {
  d: "M117.696 34.4433C113.329 38.4436 108.301 38.3335 102.906 36.9756C101.108 36.5352 98.3922 35.5076 95.3461 34.5901C89.8411 32.9386 85.8041 34.1497 84.0425 34.9204C80.8129 36.5719 79.4917 38.9574 79.1614 39.3978C79.6385 38.7739 81.7304 34.5901 88.0795 33.379C91.5293 32.8285 95.6764 33.5625 100.08 34.7736C104.411 35.9113 109.439 37.9665 114.357 35.8379C116.742 34.8837 118.871 33.2689 119.935 31.1036C121.073 28.9383 120.669 26.3693 119.238 24.6444C117.99 22.7727 115.788 21.7451 113.88 22.2589C111.971 22.6993 110.54 24.3875 110.503 26.039C110.503 26.406 110.577 26.7363 110.65 27.1033C110.944 27.7639 111.531 28.6814 112.779 28.9383C114.834 29.3053 113.623 27.6171 113.99 26.4794C114.393 25.3417 115.127 24.7912 114.1 23.9104C114.1 23.9104 117.917 24.4976 116.742 27.9474C116.742 27.9474 116.302 28.6447 116.706 29.0484C117.109 29.4521 117.66 28.7181 117.66 28.7181C117.66 28.7181 116.889 31.8009 113.329 30.9568C109.953 30.1861 108.888 25.2316 111.751 23.0296C112.302 22.5525 112.999 22.1488 113.77 21.9653C115.825 21.3781 118.247 22.5158 119.531 24.4242C121.036 26.2225 121.513 29.0484 120.302 31.3605C119.715 32.5349 118.797 33.5992 117.696 34.4433Z",
  fill: "url(#paint13_linear)"
}), React.createElement("path", {
  d: "M81.8413 30.8833C81.8413 30.8833 80.9238 33.0486 82.9423 32.8651C84.9241 32.6816 89.218 27.0665 94.2459 28.6446C99.2738 30.2227 100.925 30.1126 102.393 28.7547C102.393 28.7547 100.522 32.4981 96.8516 31.5439C93.1816 30.6264 84.3736 30.2961 78.9053 38.4068C78.942 38.4068 78.6484 33.3422 81.8413 30.8833Z",
  fill: "url(#paint14_linear)"
}), React.createElement("path", {
  d: "M110.797 34.8837C108.228 36.7554 105.439 35.4709 102.76 34.2231C99.2737 32.6083 95.934 32.9019 95.934 32.9019C95.934 32.9019 99.4572 31.8743 103.347 33.0854C107.238 34.3332 110.577 32.5349 110.944 30.5164C110.981 30.5531 113.403 32.9753 110.797 34.8837Z",
  fill: "url(#paint15_linear)"
}), React.createElement("path", {
  d: "M114.211 39.2877C114.467 39.8749 114.504 40.4988 112.816 41.0493C111.715 41.3796 110.32 41.3062 109.146 41.1227C107.348 40.8658 105.733 40.5355 105.733 40.5355C105.733 40.5355 103.898 40.4254 104.889 42.3338C104.889 42.3338 103.604 42.0402 102.723 40.6823C101.843 39.3611 98.9434 37.1224 98.0259 38.3702C97.1084 39.618 98.7599 40.0217 97.3286 41.5998C97.3286 41.5998 93.6586 35.9113 88.9977 35.6177C84.6304 35.3241 82.1348 37.4527 82.1348 37.4527C82.1348 37.4527 85.8415 32.8652 94.833 35.4342C103.788 38.0399 104.705 39.9116 108.926 39.5079C108.926 39.5079 111.642 39.3244 112.889 38.9207C113.366 38.8106 114.027 38.884 114.211 39.2877Z",
  fill: "url(#paint16_linear)"
}), React.createElement("path", {
  d: "M3.52313 34.4433C7.89044 38.4803 12.9183 38.3702 18.3132 37.0123C20.1115 36.5719 22.8273 35.5443 25.8734 34.6268C31.3785 32.9753 35.4155 34.1864 37.1771 34.9571C40.4067 36.6086 41.7279 38.9941 42.0582 39.4345C41.5811 38.8106 39.4892 34.6268 33.1401 33.4157C29.727 32.8652 25.5798 33.5992 21.1758 34.8103C16.8452 35.948 11.8173 38.0032 6.89953 35.8746C4.51403 34.9204 2.38543 33.3056 1.32113 31.1403C0.183429 28.9383 0.587129 26.3693 1.98173 24.6444C3.22953 22.7727 5.43153 21.7451 7.33993 22.2589C9.24834 22.6993 10.6796 24.3875 10.7163 26.039C10.7163 26.406 10.6429 26.7363 10.5695 27.1033C10.2759 27.7639 9.68874 28.6814 8.44094 28.9383C6.38573 29.3053 7.59684 27.6171 7.22984 26.4794C6.82613 25.3417 6.09213 24.7912 7.11973 23.9104C7.11973 23.9104 3.30293 24.4976 4.47733 27.9474C4.47733 27.9474 4.91773 28.6447 4.51403 29.0484C4.11033 29.4521 3.55983 28.7181 3.55983 28.7181C3.55983 28.7181 4.33053 31.8009 7.89044 30.9568C11.2668 30.1861 12.3311 25.2316 9.46854 23.0296C8.91804 22.5525 8.22074 22.1488 7.45003 21.9653C5.39483 21.3781 2.97263 22.5158 1.68813 24.4242C0.183429 26.2225 -0.293671 29.0484 0.91743 31.3605C1.50463 32.5349 2.42213 33.5992 3.52313 34.4433Z",
  fill: "url(#paint17_linear)"
}), React.createElement("path", {
  d: "M39.3423 30.8833C39.3423 30.8833 40.2598 33.0486 38.2413 32.8651C36.2595 32.6816 31.9656 27.0665 26.9377 28.6446C21.9098 30.2227 20.2583 30.1126 18.7903 28.7547C18.7903 28.7547 20.662 32.4981 24.332 31.5439C28.002 30.6264 36.81 30.2961 42.2783 38.4068C42.2783 38.4068 42.5719 33.3422 39.3423 30.8833Z",
  fill: "url(#paint18_linear)"
}), React.createElement("path", {
  d: "M10.4228 34.8837C12.9918 36.7554 15.781 35.4709 18.4601 34.2231C21.9466 32.6083 25.2863 32.9019 25.2863 32.9019C25.2863 32.9019 21.7631 31.8743 17.8729 33.0854C13.9827 34.3332 10.643 32.5349 10.276 30.5164C10.2393 30.5531 7.81706 32.9753 10.4228 34.8837Z",
  fill: "url(#paint19_linear)"
}), React.createElement("path", {
  d: "M7.00955 39.2877C6.75265 39.8749 6.71595 40.4988 8.40415 41.0493C9.50515 41.3796 10.8998 41.3062 12.0742 41.1227C13.8725 40.8658 15.4873 40.5355 15.4873 40.5355C15.4873 40.5355 17.3223 40.4254 16.3314 42.3338C16.3314 42.3338 17.6159 42.0402 18.4967 40.6823C19.3775 39.3611 22.2768 37.1224 23.1943 38.3702C24.1118 39.618 22.4603 40.0217 23.8916 41.5998C23.8916 41.5998 27.5616 35.9113 32.2225 35.6177C36.5898 35.3241 39.0854 37.4527 39.0854 37.4527C39.0854 37.4527 35.3787 32.8652 26.4239 35.4709C17.4324 38.0399 16.5149 39.9483 12.3311 39.5446C12.3311 39.5446 9.61525 39.3611 8.36745 38.9574C7.85365 38.8106 7.19305 38.884 7.00955 39.2877Z",
  fill: "url(#paint20_linear)"
}), React.createElement("path", {
  d: "M77.7675 23.2498C77.7675 32.8652 69.9871 40.6456 60.3716 40.6456C50.7562 40.6456 42.9758 32.8652 42.9758 23.2498C42.9758 13.6343 50.7562 5.85394 60.3716 5.85394C69.9871 5.85394 77.7675 13.671 77.7675 23.2498Z",
  stroke: "url(#paint21_linear)",
  strokeWidth: 1.30968,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M39.746 26.8096C37.5807 -6.40388 84.3733 -5.00928 81.3639 26.9197",
  stroke: "url(#paint22_linear)",
  strokeWidth: 1.30968,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M32.2227 41.9667C35.5257 39.9115 37.7277 36.9388 42.0216 39.4711C40.5903 38.26 39.3058 38.1132 38.425 38.1132C35.4156 38.0031 33.1402 41.7465 31.1951 40.7556C32.1493 39.728 31.0116 38.8472 30.1308 38.9573C29.1766 39.0674 28.5894 40.1684 28.883 41.0859C29.3601 42.5906 31.3419 42.5172 32.2227 41.9667Z",
  fill: "url(#paint23_linear)"
}), React.createElement("path", {
  d: "M88.8875 42.2236C85.5845 40.1684 83.3825 37.1957 79.0886 39.728C80.5199 38.5169 81.8044 38.3701 82.6852 38.3701C85.6946 38.26 87.97 42.0034 89.9151 41.0125C88.9609 39.9849 90.0986 39.1041 90.9794 39.2142C91.9336 39.3243 92.5208 40.4253 92.2272 41.3428C91.7501 42.8842 89.7683 42.7741 88.8875 42.2236Z",
  fill: "url(#paint24_linear)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 50.8686,
  y1: 24.2781,
  x2: 69.9861,
  y2: 24.2781,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 0.0151036,
  y1: 43.8018,
  x2: 120.848,
  y2: 43.8018,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 0.0151036,
  y1: 61.0876,
  x2: 120.848,
  y2: 61.0876,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 7.15756,
  y1: 52.4084,
  x2: 17.6153,
  y2: 52.4084,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 18.2777,
  y1: 52.4085,
  x2: 27.9282,
  y2: 52.4085,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 29.1044,
  y1: 52.4085,
  x2: 38.7548,
  y2: 52.4085,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 39.8211,
  y1: 52.3717,
  x2: 51.6732,
  y2: 52.3717,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 56.3723,
  y1: 52.4084,
  x2: 65.3623,
  y2: 52.4084,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 63.9328,
  y1: 52.2432,
  x2: 74.4273,
  y2: 52.2432,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 75.126,
  y1: 52.3717,
  x2: 84.1527,
  y2: 52.3717,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 84.6316,
  y1: 52.2432,
  x2: 95.126,
  y2: 52.2432,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 95.6045,
  y1: 52.3533,
  x2: 103.494,
  y2: 52.3533,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 104.633,
  y1: 52.3717,
  x2: 113.953,
  y2: 52.3717,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 79.1666,
  y1: 30.6048,
  x2: 120.986,
  y2: 30.6048,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 78.9082,
  y1: 33.3865,
  x2: 102.392,
  y2: 33.3865,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 95.936,
  y1: 33.1719,
  x2: 112.003,
  y2: 33.1719,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 82.1388,
  y1: 38.4936,
  x2: 114.34,
  y2: 38.4936,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 0.236795,
  y1: 30.6232,
  x2: 42.0563,
  y2: 30.6232,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 18.7932,
  y1: 33.3865,
  x2: 42.2842,
  y2: 33.3865,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 9.21868,
  y1: 33.1719,
  x2: 25.2856,
  y2: 33.1719,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 6.88232,
  y1: 38.5023,
  x2: 39.084,
  y2: 38.5023,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 60.3716,
  y1: 5.85394,
  x2: 60.158,
  y2: 41.0573,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F3C17D"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBBA78",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 60.5881,
  y1: 2.43298,
  x2: 60.5001,
  y2: 27.2102,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F3C17D"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBBA78",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 28.8087,
  y1: 40.2196,
  x2: 42.021,
  y2: 40.2196,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 79.0903,
  y1: 40.4817,
  x2: 92.3026,
  y2: 40.4817,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#BC945D"
}), React.createElement("stop", {
  offset: 0.2784,
  stopColor: "#957040"
}), React.createElement("stop", {
  offset: 0.4259,
  stopColor: "#C79B60"
}), React.createElement("stop", {
  offset: 0.5584,
  stopColor: "#EEBC79"
}), React.createElement("stop", {
  offset: 0.6275,
  stopColor: "#FDC983"
}), React.createElement("stop", {
  offset: 0.7085,
  stopColor: "#EBBA78"
}), React.createElement("stop", {
  offset: 0.8693,
  stopColor: "#BE935B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#957040"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  y: 0.450562,
  width: 121,
  height: 61.1648,
  fill: "white"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 121,
    height: 62,
    viewBox: "0 0 121 62",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.a28c20ec.svg";
export { ForwardRef as ReactComponent };